var $72d8619cd88e29aa$exports = {};
$72d8619cd88e29aa$exports = {
    "colorFormat": `\u{426}\u{432}\u{435}\u{442}\u{435}\u{43D} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}`,
    "hex": `\u{448}\u{435}\u{441}\u{442}\u{43D}\u{430}\u{434}\u{435}\u{441}\u{435}\u{442}\u{438}\u{447}\u{435}\u{43D}`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$72d8619cd88e29aa$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
